export default "__VITE_ASSET__Dk4W9pIg__"